// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0640c500","316":"4109715f","365":"0577f5b6","369":"ab4605a0","377":"4029e32b","453":"95eba27e","577":"1e3a7109","727":"853ed1a7","760":"b88a7e48","775":"6f34a3f7","819":"0aae42ec","858":"0cf32cf8","919":"cb279f87"}[chunkId] + ".chunk.js";
};